import request from '@/utils/axios';

export const getApp = () => request.get('/auth/open/app');

export const org = params => request.get('/auth/org', {params});
export const myOrgInfo = () => request.get('/auth/org/my');
export const createOrg = p => request.post('/auth/org', p);
export const updateOrg = p => request.put('/auth/org', p);
